/** The text for an SSO-only account or company, the same after a sign-in and after a sign-up. */
export const SSO_REQUIRED = "Your organization requires SSO. Sign in through your organization's SSO provider.";
/** The text for a personal email at sign-up, the same after an email and after a Google sign-up. */
export const WORK_EMAIL_REQUIRED = 'Please use your work email to create a RudderStack account.';

/** Copy for the codes the auth routes put on `/login?error=` or return from `POST /auth/session`. */
const SIGN_IN_ERROR_MESSAGES: Record<string, string> = {
  rudderstack_oauth_failed: 'RudderStack login failed. Please try again.',
  login_failed: 'Login failed. Please try again.',
  invalid_request: 'Login failed. Please try again.',
  invalid_token: 'We could not verify your sign-in. Please try again.',
  // ACT2-879: a sign-out in this browser ended the session while a renewal was on its way.
  session_ended: 'Your session ended. Sign in again.',
  sign_in_unavailable: 'Sign-in is unavailable right now. Please try again later.',
  federated_signin_failed: 'Sign-in with Google or SSO failed. Please try again.',
  use_password: 'Please sign in with your email and password.',
  use_sso: SSO_REQUIRED,
  work_email_required: WORK_EMAIL_REQUIRED,
  signup_required: "You don't have a RudderStack account yet. Create an account to get started.",
  invite_unavailable:
    'No pending invite matches the account you used. Sign in with the invited email, or ask for a new invite.',
};

const UNKNOWN_SIGN_IN_ERROR = 'Sign-in failed. Please try again.';

/**
 * `?error=` is attacker-supplied, so index the map with `Object.hasOwn` rather than `[]`:
 * a bare lookup reaches Object.prototype, and `?error=__proto__` would yield an object that
 * React refuses to render — blanking a public page. An unknown code gets the general message,
 * so a crafted link cannot put its own text on the page.
 */
export function signInErrorMessage(code: string): string {
  return Object.hasOwn(SIGN_IN_ERROR_MESSAGES, code) ? SIGN_IN_ERROR_MESSAGES[code]! : UNKNOWN_SIGN_IN_ERROR;
}
